var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "border-r py-2 px-3 item-holder",
      staticStyle: { width: "15rem", height: "80px" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.handleCreateBtnClicked.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-row items-center content-center mt-4 ml-3" },
        [
          _c("span", [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "13",
                  height: "12",
                  viewBox: "0 0 13 12",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M6.50781 0C3.19581 0 0.507812 2.688 0.507812 6C0.507812 9.312 3.19581 12 6.50781 12C9.81981 12 12.5078 9.312 12.5078 6C12.5078 2.688 9.81981 0 6.50781 0ZM8.90781 6.6H7.10781V8.4C7.10781 8.73 6.83781 9 6.50781 9C6.17781 9 5.90781 8.73 5.90781 8.4V6.6H4.10781C3.77781 6.6 3.50781 6.33 3.50781 6C3.50781 5.67 3.77781 5.4 4.10781 5.4H5.90781V3.6C5.90781 3.27 6.17781 3 6.50781 3C6.83781 3 7.10781 3.27 7.10781 3.6V5.4H8.90781C9.23781 5.4 9.50781 5.67 9.50781 6C9.50781 6.33 9.23781 6.6 8.90781 6.6Z",
                    fill: "#1A7BEE",
                  },
                }),
              ]
            ),
          ]),
          _c("span", { staticClass: "add-text ml-4" }, [
            _vm._v(_vm._s(_vm.message)),
          ]),
        ]
      ),
      _vm.showProjectModal
        ? _c("ProjectModal", {
            attrs: {
              companyId: _vm.companyId,
              currentUser: _vm.currentUser,
              data: _vm.projectInfoForModal,
              isEdittingLocked: _vm.isEdittingLocked,
            },
            on: {
              close: _vm.handleCloseModal,
              projectUpdated: _vm.refetchCollection,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "customHeader",
                  fn: function ({ title }) {
                    return [
                      _c("SchedulerCustomModalHeader", {
                        attrs: {
                          linkObject: _vm.linkToProject,
                          buttonText: title,
                          isEdittingLocked: _vm.isEdittingLocked,
                        },
                        on: { editClicked: _vm.handleEditClick },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              4128683522
            ),
          })
        : _vm._e(),
      _vm.showActivityModal
        ? _c("ActivityFormModal", {
            attrs: {
              showDialog: _vm.modalShown,
              project: _vm.projectInfoForModal,
              projectActivity: _vm.activityInfoForModal,
              isEdittingLocked: _vm.shouldBlockEditting,
              currentUserRole: _vm.currentUser.role,
              companyId: _vm.companyId,
            },
            on: {
              close: _vm.handleCloseModal,
              activityUpdated: _vm.handleCollectionUpdated,
              activityAdded: _vm.handleCollectionUpdated,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "customHeader",
                  fn: function ({ title }) {
                    return [
                      _c("SchedulerCustomModalHeader", {
                        attrs: {
                          linkObject: _vm.linkToProjectActivities,
                          buttonText: title,
                          isEdittingLocked: _vm.shouldBlockEditting,
                          linkText: "Go To Project Activities List",
                        },
                        on: { editClicked: _vm.handleEditClick },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              1051539805
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }